const convertStatusLoan = (type) => {
  let response = type;
  switch (type) {
    case "NOT_PAYMENT_DATE":
      response = <span style={{color:"#6C757D"}}>ຍັງບໍ່ຮອດມື້ຊຳລະ</span>;
      break;
    case "WAITING":
      response = <span style={{color:"#FF8A00"}}>ລໍຖ້າຊຳລະ</span>;
      break;
    case "WAITTING":
      response = <span style={{color:"#FF8A00"}}>ລໍຖ້າຊຳລະ</span>;
      break;
    case "SUCCESS":
      response = <span style={{color:"#0DCD5A"}}>ຊຳລະເງິນສຳເລັດ</span>;
      break;
    case "ARREARS":
      response = <span style={{color:"#FF0000"}}>ຄ້າງຊຳລະ</span>;
      break;
    default:
    // code block
  }
  return response;
};

export default convertStatusLoan;
